"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLocalesSchema = exports.APP_BASE_DEFAULT_LOCALE = exports.AppBaseLocaleSchema = void 0;
exports.appBaseLocalesAddedByApp = appBaseLocalesAddedByApp;
exports.newAppBaseLocales = newAppBaseLocales;
exports.appSeedLocaleIssues = appSeedLocaleIssues;
const zod_1 = require("zod");
/** Locale code format of an AppBase and of the Apps it hosts. */
exports.AppBaseLocaleSchema = zod_1.z.string().min(2);
/** Default locale of an AppBase created without one. */
exports.APP_BASE_DEFAULT_LOCALE = 'en';
/**
 * Content locales an App ships with its seed rows. An App without this
 * declaration ships no locale-specific content.
 */
exports.AppLocalesSchema = zod_1.z
    .object({
    defaultLocale: exports.AppBaseLocaleSchema,
    availableLocales: zod_1.z.array(exports.AppBaseLocaleSchema).min(1),
})
    .strict()
    .superRefine((locales, ctx) => {
    if (!locales.availableLocales.includes(locales.defaultLocale)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'App Module defaultLocale must be one of its availableLocales',
            path: ['defaultLocale'],
        });
    }
    locales.availableLocales.forEach((locale, index) => {
        if (locales.availableLocales.indexOf(locale) === index)
            return;
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `App Module availableLocales must be unique: ${locale}`,
            path: ['availableLocales', index],
        });
    });
});
/** Locales an App adds to an AppBase, in the App's order. */
function appBaseLocalesAddedByApp(appBase, app) {
    return (app.locales?.availableLocales ?? []).filter(locale => !appBase.availableLocales.includes(locale));
}
/** Locales of a new AppBase after this App is installed into it. */
function newAppBaseLocales(app) {
    const defaultLocale = app.locales?.defaultLocale ?? exports.APP_BASE_DEFAULT_LOCALE;
    return {
        defaultLocale,
        availableLocales: [
            defaultLocale,
            ...appBaseLocalesAddedByApp({ availableLocales: [defaultLocale] }, app),
        ],
    };
}
/** Seed rows whose `locale` cell the App's declared locales do not cover. */
function appSeedLocaleIssues(app, sources) {
    const issues = [];
    for (const [sourceKey, source] of Object.entries(sources)) {
        const column = source.columns?.find(candidate => candidate.name?.toLowerCase() === 'locale');
        if (!column)
            continue;
        for (const row of source.rows ?? []) {
            const locale = row.cells?.[column.id]?.value;
            if (typeof locale !== 'string' || !locale.trim())
                continue;
            if (!app.locales) {
                issues.push(`locales: seed row ${sourceKey}/${row.id} has locale "${locale}" but app.json declares no locales`);
            }
            else if (!app.locales.availableLocales.includes(locale)) {
                issues.push(`locales: seed row ${sourceKey}/${row.id} has locale "${locale}" outside app.json locales.availableLocales [${app.locales.availableLocales.join(', ')}]`);
            }
        }
    }
    return issues;
}
